export default {
  width    : 600,
  height   : 400,
  autoplay : true,
  service  : 'daum_searchview',
  profile  : 'HIGH',
  wmode    : 'opaque',
  style    : { width: '620px', height: '347px' },
  isKakaoTV: false
};


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/kakaotv-url-player/default-configs.js
 **/